import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/hooks/useAuth";
import Navbar from "@/components/feature/Navbar";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { NavbarRenderedContext } from "@/components/feature/navbar-context";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <Navbar />
          <NavbarRenderedContext.Provider value>
            <AppRoutes />
          </NavbarRenderedContext.Provider>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
